module.exports = 
  class Sockets

    constructor:->
      @connected = false
      @url = window.location.host+"/webc"
      @observers = []
      @maxwait = 30000
      @maxtries = 10
      @retry_timeout=1000
      @connect()

    on:(name,cback)->
      @observers.push({name:name,cback:cback})

    emit:(name,data)->
      if @connected
        @connection.send(JSON.stringify({name:name,data:data}))
      else
        # perhaps push onto queue, then send when reconnected?
        console.log "could not send",name

    connect:->
      console.log "connecting"
      if !@connected && @maxtries > 0
        @maxtries--
        protocol = if window.location.protocol == "https:" then "wss://" else "ws://"
        socket = new WebSocket(protocol+@url+"?_csrf="+window.csrf+"&v=0.2")
        socket.onopen = (event)=>
          @connected = true
          @connection = socket
          @reconnecting = false
        socket.onmessage = (res)=>
          message = JSON.parse(res.data)
          @observers.forEach (ob)=> ob.cback(message.data) if message.name == ob.name
        socket.onerror = (event)=>
          console.log "socket error",event
        socket.onclose = (e)=>
          console.log("onclose",e.code,e) 
          @connected = false
          if !@reconnecting && e.code == 1006 # 1006 abnormal closure, ie server going down
            @reconnecting = true
            @reconTimer = setTimeout =>
              @connect()
              @retry_timeout *= 1.5
              @retry_timeout = @maxwait if @retry_timeout > @maxwait
            ,@retry_timeout
        window.addEventListener "beforeunload",=>
          socket.close()